import { render } from "./AgencyDialogHeader.vue?vue&type=template&id=1261ec3a&scoped=true"
import script from "./AgencyDialogHeader.vue?vue&type=script&lang=js"
export * from "./AgencyDialogHeader.vue?vue&type=script&lang=js"

import "./AgencyDialogHeader.vue?vue&type=style&index=0&id=1261ec3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1261ec3a"]])

export default __exports__